import React from 'react';
import { useGoodsReviewsSummary } from '../../queries/useGoodsReadReviewsSummary';
import { Colors, Flex, Typography } from '@banhala/ui-kit';
import Svg, { Line } from 'react-native-svg';

export const EvaluationList: React.FC = () => {
  const { data: reviewsSummary } = useGoodsReviewsSummary();

  if (reviewsSummary.summary.length === 0) return;

  return (
    <Flex padding={{ horizontal: 16, vertical: 16 }} gap={12}>
      {reviewsSummary.summary.map(review => (
        <Flex.Row gap={8} alignItems={'center'}>
          <Flex width={40}>
            <Typography type={'body2'} color={'content_secondary'}>
              {review.name}
            </Typography>
          </Flex>
          <Typography type={'subtitle2'} color={'content_primary'}>
            {review.highest}
          </Typography>
          <Flex flex={1}>
            <Svg height="1" width="100%">
              <Line
                x1="0"
                y1="1"
                x2="100%"
                y2="1"
                stroke={Colors.border_secondary}
                strokeWidth="2"
                strokeDasharray="5, 3" // dash 5px, gap 3px
              />
            </Svg>
          </Flex>

          <Typography type={'subtitle2'} color={'content_primary'}>
            {review.percent}%
          </Typography>
        </Flex.Row>
      ))}
    </Flex>
  );
};
